import styled, { css } from 'styled-components';
import { ReactComponent as ResolveIcon } from '../../../../../assets/icons/message-ignore.svg';
import { ReactComponent as TrashIcon } from '../../../../../assets/icons/v2/trash.svg';
import { ReactComponent as ViewIcon } from '../../../../../assets/icons/view.svg';

const iconStyle = css`
  width: 16px;
`;

const ActionButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

const StyledResolveIcon = styled(ResolveIcon)`
  ${iconStyle}
`;

const StyledTrashIcon = styled(TrashIcon)`
  ${iconStyle}
`;

const StyledViewIcon = styled(ViewIcon)`
  ${iconStyle}
`;

export {
  ActionButtonContainer,
  StyledResolveIcon,
  StyledTrashIcon,
  StyledViewIcon,
};
